import { createSlice } from "@reduxjs/toolkit";
import appApi from "../api";

type Client = {
  id: string;
  name: string;
  comment: string;
  rating: string;
  createdAt: Date;
  images?: string[]; 
};

type ClientState = {
  clients: Client[];
  loading: boolean;
  error: string | null;
};
const initialState: ClientState = {
  clients: [],
  loading: false,
  error: null,
};
const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClients: (state, action) => {
      state.clients = action.payload;
    },
    // addOffice: (state, action) => {
    //   state.offices.push(action.payload);
    // },
    // updateOffice: (state, action) => {
    //   const index = state.offices.findIndex(
    //     (office) => office.id === action.payload.id
    //   );
    //   if (index !== -1) {
    //     state.offices[index] = action.payload;
    //   }
    // },
    // deleteOffice: (state, action) => {
    //   state.offices = state.offices.filter(
    //     (office) => office.id !== action.payload
    //   );
    // }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        appApi.endpoints.fetchOurClients.matchFulfilled,
        (state, action) => {
          state.clients = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
    }
});
export const { setClients, } = clientSlice.actions;
export default  clientSlice.reducer;
export const getCleints = (state: { client: ClientState }) => state.client.clients;
// export const selectLoading = (state: { office: OfficeState }) => state.office.loading;
